import { createSlice } from "@reduxjs/toolkit";

const isRowSolutionsOrAsiaGames =
  window.location.hostname.includes('row.solutions') ||
  window.location.hostname.includes('asia.games');

const sections = isRowSolutionsOrAsiaGames ?
  ["vendorHot", "vendorNew", "buybonus", "all"] :
  ["buybonus", "jackpot", "tournament", "all"];

export const sectionsSlice = createSlice({
  name: "sections",
  initialState: {
    sections,
    activeSection: null,
    isSingle: false,
  },
  reducers: {
    setActiveSection(state, action) {
      state.activeSection = action.payload;
    },
    setSingleSection(state, action) {
      state.isSingle = action.payload;
    },
  },
});

export const sectionsSelector = (state) => state.sections;
export const { setActiveSection, setSingleSection } = sectionsSlice.actions;
export default sectionsSlice.reducer;
